import { Div } from "atomize"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import ProfileContainer from "../ProfileContainer"

const Profile = () => {
	const location = useLocation()

	useEffect(() => {
		// Gestisce il callback OAuth Google dopo il redirect
		const params = new URLSearchParams(location.search)
		const code = params.get("code")
		const error = params.get("error")
		if (code || error) {
			window.opener?.postMessage({ code, error }, window.location.origin)
			window.close()
		}
	}, [])

	return (
		<Div>
			<ProfileContainer />
			<Div h="10.25rem" pos="relative" />
		</Div>
	)
}

export default Profile
